import "./agent.scss";

import { Outlet } from "react-router-dom";

import { FilterAgentProvider } from "./filter-agent/filter-agent.context";

export function Agent() {
  return (
    <div id="ShellAgent" className="agent">
      <FilterAgentProvider>
        <Outlet />
      </FilterAgentProvider>
    </div>
  );
}

export default Agent;
